export default {
  init() {
    // JavaScript to be fired on the brokers page
    $(document).ready(function(){
      $('select.filterby').change(function() {

        var filters = $.map($('select.filterby').toArray(), function(e){
          return $(e).val();
        }).join('.');
        $('div#broker-container').find('div').hide();
        $('div#broker-container').find('div.' + filters).show();
      });

      $('#firstNameInput').keyup(function() {
        // Declare variables
        var input, filter, container, div, a, i, txtValue;
        input = document.getElementById('firstNameInput');
        filter = input.value.toUpperCase();
        container = document.getElementById('broker-container');
        div = container.getElementsByTagName('div');

        // Loop through all items, and hide those who don't match the search query
        for (i = 0; i < div.length; i++) {
          a = div[i].getElementsByTagName('h3')[0];
          txtValue = a.textContent || a.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            div[i].style.display = '';
          } else {
            div[i].style.display = 'none';
          }
        }
      });

      $('#lastNameInput').keyup(function() {
        // Declare variables
        var input, filter, container, div, a, i, txtValue;
        input = document.getElementById('lastNameInput');
        filter = input.value.toUpperCase();
        container = document.getElementById('broker-container');
        div = container.getElementsByTagName('div');

        // Loop through all items, and hide those who don't match the search query
        for (i = 0; i < div.length; i++) {
          a = div[i].getElementsByTagName('h5')[0];
          txtValue = a.textContent || a.innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            div[i].style.display = '';
          } else {
            div[i].style.display = 'none';
          }
        }
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the brokers page, after the init JS
  },
};
